import { Link } from 'react-router-dom';
import { useStudentAuthContext } from './useStudentAuthContext';
import { useStudentLogout} from './useStudentLogout';

const StudentHeader = () => {

     const {logout} = useStudentLogout();

     const handleClick = () =>{
         logout();
     }

     const {studentuser} = useStudentAuthContext();

     return (
        <>
       <nav  className="navbar navbar-dark navbar-expand-md " >
            <div className="container-fluid">
                <Link className="navbar-brand d-flex align-items-center" to="/">
          <img 
            src="https://alhaidery.org/wp-content/uploads/2022/06/logo1-1.png" 
            alt="Al Haidery Logo" 
            style={{ 
              height: '100px', 
              background: '#fff', 
              padding: '2px' 
            }}
            className="d-inline-block align-top"
          />
        </Link>
                <button 
                className="navbar-toggler" 
                type="button" 
                data-bs-toggle="collapse" 
                data-bs-target="#navbarNav" 
                aria-controls="navbarNav" 
                aria-expanded="false" 
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav  ml-auto">
                    <li className="nav-item">
                         <Link className="nav-link" aria-current="page" to="/">HOME</Link>
                    </li>  

                    <li className="nav-item">
                         {/* <Link className="nav-link" aria-current="page" to="/dashboard">SEARCH</Link> */}
                    </li>  

                    {
                         !studentuser && (
                              <li className="nav-item">
                              <Link className="nav-link" aria-current="page" to="/student/login">LOGIN</Link>
                         </li>  
     
                         )
                    }
                   
                    {
                         studentuser && (
                              <>
                                    <li className="nav-item">
                                             <Link className="nav-link" aria-current="page" to="/student/application">APPLICATION</Link>
                                    </li>  
                                    <li className="nav-item">
                                             <Link className="nav-link" aria-current="page"  to="/student/documents">DOCUMENTS</Link>
                                    </li>          

                                   <li>
                                        <Link className="nav-link" aria-current="page" onClick={handleClick}>LOGOUT</Link>
                                   </li>
                              </>
                         )
                    }
                   
                </ul>
                </div>
            </div>
        </nav>
        </>
     );
}

export default StudentHeader;